var _rect, _circle, _circle2, _circle3, _circle4, _rect2, _rect3, _rect4, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForms1A7A(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 143,
    viewBox: "0 0 189 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 188.816,
    height: 143,
    rx: 10.01,
    fill: "#F2F2F3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5336,
    cy: 32.89,
    r: 12.155,
    stroke: "#9EB1D8",
    strokeWidth: 4.29
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5337,
    cy: 71.5002,
    r: 7.15,
    fill: "#5568FE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5336,
    cy: 71.5002,
    r: 12.155,
    stroke: "#5568FE",
    strokeWidth: 4.29
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5336,
    cy: 110.11,
    r: 12.155,
    stroke: "#9EB1D8",
    strokeWidth: 4.29
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80.5243,
    y: 26.3787,
    width: 72.1942,
    height: 13.8835,
    rx: 6.94175,
    fill: "#9EB1D8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80.5243,
    y: 63.8641,
    width: 52.7573,
    height: 15.2718,
    rx: 7.63592,
    fill: "#9EB1D8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 80.5243,
    y: 102.738,
    width: 87.466,
    height: 13.8835,
    rx: 6.94175,
    fill: "#9EB1D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3787 22.2136V115.612",
    stroke: "#2A2A2A",
    strokeWidth: 2.7767,
    strokeLinecap: "round",
    strokeDasharray: "5.55 8.33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5049 123.389C26.9508 124.158 25.8065 124.158 25.2524 123.389L20.7507 117.145C20.0887 116.227 20.7449 114.945 21.8769 114.945L30.8803 114.945C32.0124 114.945 32.6685 116.227 32.0065 117.145L27.5049 123.389Z",
    fill: "#2B2B2B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForms1A7A);
export default __webpack_public_path__ + "static/media/forms1a7a.dea0544cc0b522b633109bba3050f417.svg";
export { ForwardRef as ReactComponent };